import { createSite, deleteSite, getSiteBySiteAddress, getSites, updateSite } from "../../api/site";
import { getDomainSite, setDomainSite } from "../../utils/site";
import _ from "lodash";

const site = {
    namespaced: true,
    state: {
        site: getDomainSite(),
        sites: {
            total: 0,
            count: 0,
            data: [],
        },
    },
    getters: {
        getSite: (state) => (id) => {
            return state.sites.data.find((u) => u._id === id);
        },
        isSuspend: (state) => {
            return _.get(state.site, "suspend", false);
        },
    },
    mutations: {
        SET_SITES: (state, payload) => {
            state.sites = payload;
        },
        ADD_SITE: (state, payload) => {
            state.sites.data.push(payload);
            state.sites.total++;
        },
        UPDATE_SITE: (state, payload) => {
            let adminUser = state.sites.data.findIndex((p) => p._id === payload._id);
            state.sites.data[adminUser] = payload;
        },
        GET_SITE_BY_SITE_ADDRESS: (state, payload) => {
            state.site = payload;
        },
        REMOVE_SITE: (state, id) => {
            state.sites.data = state.sites.data.filter((u) => u._id !== id);
            state.sites.total--;
        },
    },
    actions: {
        getSites({ commit }, payload) {
            return getSites(payload.perPage, payload.page, payload.extendedMeta).then((response) => {
                commit("SET_SITES", response.data);
            });
        },
        getSite({ state }, id) {
            return state.sites.data.find((u) => u._id === id);
        },
        delSite({ commit }, id) {
            return deleteSite(id).then(() => {
                commit("REMOVE_SITE", id);
            });
        },
        createSite({ commit }, payload) {
            return createSite(payload).then((response) => {
                commit("ADD_SITE", response.data);
            });
        },
        updateSite({ commit }, payload) {
            return updateSite(payload._id, payload).then((response) => {
                commit("UPDATE_SITE", response.data);
            });
        },
        getSiteBySiteAddress({ commit }, payload) {
            return getSiteBySiteAddress(payload).then((response) => {
                commit("GET_SITE_BY_SITE_ADDRESS", response.data);
                setDomainSite(JSON.stringify(response.data));

                return response;
            });
        },
        /*deleteAdminUser({commit}, id) {
          commit('REMOVE_ADMIN_USER', id);
          return deleteAdminUser(id);
        }*/
    },
};

export default site;
